//
// Generated by @himenon/openapi-typescript-code-generator v0.27.4
//
// OpenApi : 3.0.0
//
//
import {
  Params$AdminDocumentController_updateOneById,
  Response$AdminDocumentController_updateOneById$Status$200,
  ResponseContentType$AdminDocumentController_updateOneById,
} from '@api-client/generated/client';
import { useApiClientMutation } from '@hooks/useApiClientMutation';

export const useAdminDocumentController_updateOneById = () =>
  useApiClientMutation<
    Params$AdminDocumentController_updateOneById,
    Response$AdminDocumentController_updateOneById$Status$200[ResponseContentType$AdminDocumentController_updateOneById]
  >({ method: 'AdminDocumentController_updateOneById' });
